module.exports = __webpack_public_path__ + "img/sample-img.ca71d203.svg";